import { render } from "./Co2Tab.vue?vue&type=template&id=b2e5b212&ts=true"
import script from "./Co2Tab.vue?vue&type=script&lang=ts"
export * from "./Co2Tab.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__